import React, { useState } from "react";
import { Check, Clipboard } from "react-feather";

interface Props {
  value: string;
}

export const CopyButtonWithApproval: React.FC<Props> = ({ value }) => {
  const [isCopied, setIsCopied] = useState(false);

  React.useEffect(() => {
    let intervalId: any;
    if (isCopied) {
      intervalId = setInterval(() => {
        setIsCopied(false);
      }, 1500);
    }
    return () => {
      clearInterval(intervalId);
    };
  }, [isCopied]);

  function handleCopyToClipboard() {
    setIsCopied(true);
    navigator.clipboard.writeText(value);
  }

  return (
    <button type={`button`} onClick={handleCopyToClipboard} style={{ outline: 0 }}>
      {!isCopied ? <Clipboard size={14} className="color-link-hover" /> : <Check size={14} className="color-link" />}
    </button>
  );
};
